export const GET_PURCHASED_CANDIDATE_STATS_REQUEST = 'GET_PURCHASED_CANDIDATE_STATS_REQUEST';
export const GET_PURCHASED_CANDIDATE_STATS_SUCCESS = 'GET_PURCHASED_CANDIDATE_STATS_SUCCESS';
export const GET_PURCHASED_CANDIDATE_STATS_FAILURE = 'GET_PURCHASED_CANDIDATE_STATS_FAILURE';
